import { utils } from '@tidb-community/common';

import { LOGIN_TYPE, LOGIN_TYPE_VALUE_NAME } from './login.constants';
import { phone, phoneRegion, verifyCode, password, identifier } from '/src/form/fields';
import { sendCode } from '/src/api';

const { buildInitialValues, buildSchema, conditionalField } = utils.form;

export const form = {
  phoneRegion: { ...phoneRegion },
  phone: conditionalField(phone, { value: LOGIN_TYPE_VALUE_NAME, is: LOGIN_TYPE.VERIFY_CODE }),
  verifyCode: {
    ...conditionalField(verifyCode, { value: LOGIN_TYPE_VALUE_NAME, is: LOGIN_TYPE.VERIFY_CODE }),
    sendVerifyCode: (phone) => sendCode('login/phone', { phone }),
  },
  identifier: conditionalField(identifier, { value: LOGIN_TYPE_VALUE_NAME, is: LOGIN_TYPE.PASSWORD }),
  password: conditionalField(password, { value: LOGIN_TYPE_VALUE_NAME, is: LOGIN_TYPE.PASSWORD }),
  loginType: {
    name: LOGIN_TYPE_VALUE_NAME,
    initialValue: LOGIN_TYPE.PASSWORD,
  },
};

export const formSchema = buildSchema(form);

export const initialValues = buildInitialValues(form);
